import { images } from "../../assets/Images/assetsImages"
import { FaFacebookF, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <section className='w-full h-full flex flex-col font-montserrat border-solid border-2 border-[#41220E]'>
        <div className="w-full h-full flex flex-col items-center justify-center md:items-start md:flex-row py-10 bg-[#F5E9D7]">
            <div className='w-[80%] md:w-[50%] h-full flex flex-col justify-center items-center md:flex-row'>
                <div className='w-[40%] flex items-start justify-center'>
                    <div className="w-[100px] h-[100px] md:w-[120px] md:h-[120px] flex items-center justify-center">
                        <img src={images.FooterLogo} alt="FooterLogo"/>
                    </div>
                </div>
                <div className='w-full sm:w-[60%] flex items-center justify-center mt-5'>
                    <ul className="w-[80%] font-semibold text-xl space-y-8 text-center md:text-start">
                        <li>Careers</li>
                        <li>Press</li>
                        <li>Help Center</li>
                        <li>Wholesale</li>
                        <li>Promotion Terms</li>
                    </ul>
                </div>
            </div>
            <hr className="w-[70%] h-0.5 bg-[#41220E] border-none my-5 md:hidden"></hr>
            <div className='w-[80%] md:w-[50%] h-full flex flex-col justify-center items-center md:items-start pl-[20px] md:pl-[100px] '>
                <div className="w-[100%] lg:w-[80%] xl:w-[60%] flex flex-col items-center justify-center">
                    <ul className="w-[100%] font-medium text-xl space-y-8 text-center md:text-start">
                        <li>Get In Touch With Us <br></br>
                            Open All Days (closed for Friday prayer) <br></br>
                            8am to 11pm</li>
                    </ul>
                    <ul className="w-[100%] font-medium text-xl space-y-2 text-center md:text-start mt-8">
                        <li>+974 4148 7722</li>
                        <li>+974 7748 7722</li>
                    </ul>
                    <ul className="w-[100%] font-medium text-xl space-y-2 text-center md:text-start mt-8">
                        <li>Follow us
                        @symphonys_doha</li>
                    </ul>
                </div>
                <div className="flex py-5 mt-5 md:mt-0">
                    <div className="bg-[#41220E] rounded-full text-white p-3 mx-2">
                        <a href="https://www.example.com"> <FaFacebookF/> </a>
                    </div>
                    <div className="bg-[#41220E] rounded-full text-white p-3 mx-2">
                        <a href="https://www.example.com"> <FaInstagram/> </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="w-full bg-[#41220E] flex items-center justify-center">
            <div className="w-full sm:w-[90%] lg:w-[70%] xl:w-[50%] text-white text-md sm:text-lg md:text-xl flex xs:flex-col p-4 xs:text-center">
                <div className="xs:w-full w-[50%]">
                    <a href="privacy-policy">Privacy Policy</a>
                </div>
                <div className="xs:w-full w-[50%] pl-[100px] xs:pl-0 ">
                    <a href="terms-and-conditions">Terms and Services</a>
                </div>
            </div>
        </div>
      
    </section>
  )
}

export default Footer
